import { ApiRoutingExecutionType, IApiRoutingProfile, IApiRoutingProfileDefault } from '@cbridge-packages/api';
import { exhaustiveFail } from '@cbridge-utils/error';
import { IRoutingProfile, IRoutingProfileAttributes, RoutingExecutionType } from './routingProfile.interface';

export namespace RoutingProfileTranslator {
  export function fromApiExecutionType(type: ApiRoutingExecutionType): RoutingExecutionType {
    switch (type) {
      case ApiRoutingExecutionType.BOOK_A:
        return RoutingExecutionType.Abook;
      case ApiRoutingExecutionType.BOOK_B:
        return RoutingExecutionType.Bbook;
      case ApiRoutingExecutionType.REJECT:
        return RoutingExecutionType.Reject;
      default:
        return exhaustiveFail(type);
    }
  }

  export function toApiExecutionType(type: RoutingExecutionType): ApiRoutingExecutionType {
    switch (type) {
      case RoutingExecutionType.Abook:
        return ApiRoutingExecutionType.BOOK_A;
      case RoutingExecutionType.Bbook:
        return ApiRoutingExecutionType.BOOK_B;
      case RoutingExecutionType.Reject:
        return ApiRoutingExecutionType.REJECT;
      default:
        return exhaustiveFail(type);
    }
  }

  export function fromApi(profile: IApiRoutingProfile): IRoutingProfile {
    return {
      id: profile.id,
      name: profile.name,
      executionType: fromApiExecutionType(profile.executionType),
      minBBookDelay: profile.minBBookDelay,
      maxBBookDelay: profile.maxBBookDelay,
    };
  }

  export function toApi(profile: IRoutingProfile): IApiRoutingProfile {
    const isBBookB = profile.executionType === RoutingExecutionType.Bbook;

    return {
      id: profile.id,
      name: profile.name,
      executionType: toApiExecutionType(profile.executionType),
      ...(isBBookB && {
        minBBookDelay: profile.minBBookDelay,
        maxBBookDelay: profile.maxBBookDelay,
      }),
    };
  }

  export function defaultFromApi(profile: IApiRoutingProfileDefault): IRoutingProfileAttributes {
    return {
      executionType: fromApiExecutionType(profile.executionType),
      minBBookDelay: profile.minBBookDelay,
      maxBBookDelay: profile.maxBBookDelay,
    };
  }
}
